import { useState, useCallback } from 'react';

export const useExcepcionesValidation = () => {
  const [excepcionesTemp, setExcepcionesTemp] = useState([]);

  // Validar que hora_inicio < hora_fin
  const validarHoras = useCallback((horaInicio, horaFin) => {
    if (!horaInicio || !horaFin) return false;

    const [hInicio, mInicio] = horaInicio.split(':').map(Number);
    const [hFin, mFin] = horaFin.split(':').map(Number);

    const minutosInicio = hInicio * 60 + mInicio;
    const minutosFin = hFin * 60 + mFin;

    return minutosInicio < minutosFin;
  }, []);

  // Validar conflictos de horarios
  const validarConflictoHorario = useCallback((nuevaExcepcion, excepcionesExistentes) => {
    if (nuevaExcepcion.tipo !== 'horario_especial') return true;

    if (!nuevaExcepcion.hora_inicio || !nuevaExcepcion.hora_fin) return true;

    const [hNuevaInicio, mNuevaInicio] = nuevaExcepcion.hora_inicio.split(':').map(Number);
    const [hNuevaFin, mNuevaFin] = nuevaExcepcion.hora_fin.split(':').map(Number);

    const minutosNuevaInicio = hNuevaInicio * 60 + mNuevaInicio;
    const minutosNuevaFin = hNuevaFin * 60 + mNuevaFin;

    for (const exc of excepcionesExistentes) {
      if (exc.tipo !== 'horario_especial') continue;
      if (exc.hora_inicio === nuevaExcepcion.hora_inicio && exc.hora_fin === nuevaExcepcion.hora_fin) {
        const [hExcInicio, mExcInicio] = exc.hora_inicio.split(':').map(Number);
        const [hExcFin, mExcFin] = exc.hora_fin.split(':').map(Number);

        const minutosExcInicio = hExcInicio * 60 + mExcInicio;
        const minutosExcFin = hExcFin * 60 + mExcFin;

        if (
          (minutosNuevaInicio >= minutosExcInicio && minutosNuevaInicio < minutosExcFin) ||
          (minutosNuevaFin > minutosExcInicio && minutosNuevaFin <= minutosExcFin) ||
          (minutosNuevaInicio <= minutosExcInicio && minutosNuevaFin >= minutosExcFin)
        ) {
          return false;
        }
      }
    }

    return true;
  }, []);

  // Obtener mensaje de conflicto
  const getMensajeConflicto = useCallback((nuevaExcepcion, excepcionesExistentes) => {
    if (!nuevaExcepcion.hora_inicio || !nuevaExcepcion.hora_fin) {
      return 'La excepción no tiene horario definido';
    }

    const [hNuevaInicio, mNuevaInicio] = nuevaExcepcion.hora_inicio.split(':').map(Number);
    const [hNuevaFin, mNuevaFin] = nuevaExcepcion.hora_fin.split(':').map(Number);

    const minutosNuevaInicio = hNuevaInicio * 60 + mNuevaInicio;
    const minutosNuevaFin = hNuevaFin * 60 + mNuevaFin;

    for (const exc of excepcionesExistentes) {
      if (exc.tipo !== 'horario_especial') continue;

      const [hExcInicio, mExcInicio] = exc.hora_inicio.split(':').map(Number);
      const [hExcFin, mExcFin] = exc.hora_fin.split(':').map(Number);

      const minutosExcInicio = hExcInicio * 60 + mExcInicio;
      const minutosExcFin = hExcFin * 60 + mExcFin;

      if (minutosNuevaInicio >= minutosExcInicio && minutosNuevaInicio < minutosExcFin) {
        return `La hora de inicio ${nuevaExcepcion.hora_inicio} está dentro del horario existente ${exc.hora_inicio} - ${exc.hora_fin}`;
      }

      if (minutosNuevaFin > minutosExcInicio && minutosNuevaFin <= minutosExcFin) {
        return `La hora de fin ${nuevaExcepcion.hora_fin} está dentro del horario existente ${exc.hora_inicio} - ${exc.hora_fin}`;
      }

      if (minutosNuevaInicio <= minutosExcInicio && minutosNuevaFin >= minutosExcFin) {
        return `El horario ${nuevaExcepcion.hora_inicio} - ${nuevaExcepcion.hora_fin} envuelve completamente el horario existente ${exc.hora_inicio} - ${exc.hora_fin}`;
      }
    }

    return 'Conflicto de horarios';
  }, []);

  // Obtener excepciones en una fecha específica
  const getExcepcionesEnFecha = useCallback((fecha, excepciones, excepcionesTemp) => {
    const fechaFormulario = fecha;

    const temporales = excepcionesTemp.filter(exc => {
      const fechaTemp = exc.fecha.split('T')[0] || exc.fecha;
      return fechaTemp === fechaFormulario;
    }).length;

    const guardadas = excepciones.filter(exc => {
      const fechaDB = exc.fecha.split('T')[0];
      return fechaDB === fechaFormulario;
    }).length;

    return temporales + guardadas;
  }, []);

  // Agregar excepción temporal
  const agregarExcepcionTemp = useCallback((excepcion) => {
    setExcepcionesTemp(prev => [...prev, excepcion]);
  }, []);

  // Limpiar excepciones temporales
  const limpiarExcepcionesTemp = useCallback(() => {
    setExcepcionesTemp([]);
  }, []);

  // Combinar excepciones guardadas y temporales
  const combinarExcepciones = useCallback((guardadas, temporales) => {
    const combinadas = [...guardadas];

    temporales.forEach(temp => {
      const yaExiste = combinadas.some(guardada =>
        guardada.fecha.split('T')[0] === temp.fecha.split('T')[0] &&
        guardada.tipo === temp.tipo &&
        guardada.hora_inicio === temp.hora_inicio &&
        guardada.hora_fin === temp.hora_fin
      );
      if (!yaExiste) {
        combinadas.push({
          ...temp,
          id: `temp-${Date.now()}-${Math.random()}`,
          esTemporal: true
        });
      }
    });

    return combinadas;
  }, []);

  return {
    excepcionesTemp,
    setExcepcionesTemp,
    validarHoras,
    validarConflictoHorario,
    getMensajeConflicto,
    getExcepcionesEnFecha,
    agregarExcepcionTemp,
    limpiarExcepcionesTemp,
    combinarExcepciones
  };
};
